import { Mode } from "./new-contract/types";

const parseResIdFromCookie = (): string => {
    const resIdCookie = document.cookie.split(';')
      .find(cookie => cookie.includes('RES_TRACKINGID'));
    return resIdCookie === undefined ? '' : resIdCookie.split('=')[1];
};

const removeDepartment = (queryString: string): string => (
    queryString.replace(/department=[\d]+&?/g, '')
);

export const addFacetQueryString = (completeUrl: string, facetQueryString?: string): string => {
    return facetQueryString ? completeUrl += `&${removeDepartment(facetQueryString)}` : completeUrl;
};

export const addPreview = (completeUrl: string, wipAppChoice?: Mode, previewDate?: string): string => {
    return wipAppChoice && previewDate 
        ? completeUrl += `&mode=${wipAppChoice}&previewDate=${previewDate}` : completeUrl;
};

export const addVendor = (completeUrl: string, vendor?: string, trackingid?: string): string => {
    return vendor && trackingid 
        ? completeUrl += `&vendor=${vendor}&trackingid=${trackingid}` : completeUrl;
};

export const getResId = (productsUrl: string): string => (productsUrl && parseResIdFromCookie() ? parseResIdFromCookie() : '');


export default {
    addFacetQueryString,
    addPreview,
    addVendor,
    getResId,
}
